import { styled } from '@mui/material';

export const PREFIX = 'GridRowLabel';

export const classes = {
  label: `${PREFIX}-label`,
  collapseButton: `${PREFIX}-collapseButton`,
  titleRow: `${PREFIX}-titleRow`,
  isValuedCompanyCell: `${PREFIX}-isValuedCompanyCell`,
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.label}`]: {
    alignItems: 'center',
    display: 'flex',
    fontSize: '14px',
    height: '100%',
    justifyContent: 'space-between',
    position: 'relative',
    textAlign: 'left',
    width: '100%',
  },

  [`& .${classes.collapseButton}`]: {
    marginLeft: `${theme.spacing(1)}`,
    marginRight: 0,
  },

  [`& .${classes.titleRow}`]: {
    color: theme.palette.primary.main,
    cursor: 'cell',
    fontWeight: 700,
  },

  [`& .${classes.isValuedCompanyCell}`]: {
    fontWeight: 'bold',
  },
}));
